import config from "./config";

// Parse the JWT token to get user info
function parseJwt(token) {
  try {
    const base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}

// Check if there's a valid token
export function getSession() {
  const token = sessionStorage.getItem("qbox_id_token");
  if (!token) return null;

  const decoded = parseJwt(token);
  if (!decoded) return null;

  // Check expiry
  if (decoded.exp * 1000 < Date.now()) {
    sessionStorage.removeItem("qbox_id_token");
    return null;
  }

  return {
    token,
    email: decoded.email,
    name: decoded.name || decoded.email,
  };
}

// Redirect to Cognito Google sign-in
export function login() {
  const url =
    `https://${config.COGNITO_DOMAIN}/login?` +
    `client_id=${config.COGNITO_CLIENT_ID}` +
    `&response_type=token` +
    `&scope=${encodeURIComponent(config.COGNITO_SCOPES)}` +
    `&redirect_uri=${encodeURIComponent(config.COGNITO_REDIRECT_URI)}` +
    `&identity_provider=Google`;
  window.location.href = url;
}

// Sign out
export function logout() {
  sessionStorage.removeItem("qbox_id_token");
  const url =
    `https://${config.COGNITO_DOMAIN}/logout?` +
    `client_id=${config.COGNITO_CLIENT_ID}` +
    `&logout_uri=${encodeURIComponent(config.COGNITO_REDIRECT_URI)}`;
  window.location.href = url;
}

// Handle the redirect back from Cognito (token in URL hash)
export function handleCallback() {
  const hash = window.location.hash;
  if (!hash || !hash.includes("id_token")) return false;

  const params = new URLSearchParams(hash.substring(1));
  const idToken = params.get("id_token");

  if (idToken) {
    // Verify email is in allowed list
    const decoded = parseJwt(idToken);
    if (
      config.ALLOWED_EMAILS.length > 0 &&
      !config.ALLOWED_EMAILS.includes(decoded?.email)
    ) {
      alert(
        "Access denied. Your Google account is not authorized for this application."
      );
      return false;
    }

    sessionStorage.setItem("qbox_id_token", idToken);
    // Clean the URL
    window.history.replaceState(null, "", window.location.pathname);
    return true;
  }
  return false;
}
